import React, { useEffect, useState } from 'react'
import {
    Col,
    Card,
    Row,
} from 'reactstrap'

import { ResponsiveLine } from '@nivo/line'

import { useParams } from 'react-router-dom'

import PammManagerStatistic from '../../../network/services/pammManagerStatistic'

import { ResponsiveBar } from '@nivo/bar'

import _ from 'lodash'
import './pammManagerStatistic.css'
import { useTranslation } from 'react-i18next'

const GrowthLineGraph = (props) => {
    const { t } = useTranslation()
    const [pammManagerDetails, setPammManagerDetails] = useState([])
    const [isLoading, setIsLoading] = useState(false)

    let [dataTotalGrowth, setDataTotalGrowth] = useState(0)

    let totalGrowth = 0
    let [allGrowthData, seAllGrowthData] = useState([])

    let data = []

    useEffect(() => {
        totalGrowth = 0
        const search = async () => {
            setIsLoading(true)
            const result = await PammManagerStatistic.get(props.id)

            setPammManagerDetails(result?.details)


            let CalculateResult = result?.details?.performances?.map(performance => {
                // console.log('result?.details?.performances',result?.details?.performances)
                data.push({
                    "x": performance?.id,
                    "y": totalGrowth + performance?.monthly_growth
                })
                totalGrowth += performance?.monthly_growth
            })

            setDataTotalGrowth(totalGrowth)
            seAllGrowthData(data)

        }

        search()
    }, [])

    // console.log('allGrowthData', allGrowthData)

    return (
        <>

            <h5 style={{ textAlign: 'center', Color: '#232323', fontSize: '16px', marginBottom: '0px' }}>{t('pamm.TotalGrowth')}</h5>
            <p
                style={{
                    color: dataTotalGrowth > 0 ? '#369B70' : dataTotalGrowth < 0 ? '#E52E2E' : "black", fontSize:'24px', fontWeight:'500'
                }}>
                {dataTotalGrowth.toFixed(2)}%
            </p>
            <ResponsiveLine
                colors=' #C4A569'
                data={[{
                    "id": "profit",
                    "color": "hsl(294, 70%, 50%)",
                    "data": allGrowthData

                }]}

                curve="linear"
                type="linear"
                enableSlices='x'
                defs={[
                    {
                        id: 'gradientC',
                        type: 'linearGradient',
                        colors: [
                            { offset: 0, color: '#C4A569' },
                            { offset: 20, color: 'inherit' },
                            { offset: 80, color: '#C4A569' },
                            { offset: 100, color: '#C4A569' },
                        ],
                    }
                ]}

                fill={[
                    { match: '*', id: 'gradientC' }
                ]}

                margin={{ top: 30, bottom: 20, left: 0, right: 0 }}
                xScale={{ type: 'point' }}
                yScale={{ type: 'linear', min: 'auto', max: 'auto', stacked: true, reverse: false }}
                yFormat=" >-.2f"
                axisTop={null}
                axisRight={null}
                axisBottom={null}
                axisLeft={null}
                enableGridX={false}
                enableGridY={false}

                pointSize={0}
                pointColor={{ theme: 'background' }}
                pointBorderWidth={2}
                pointBorderColor={{ from: 'serieColor' }}
                pointLabelYOffset={-12}
                enableArea={true}
                useMesh={true}
                legends={[]}
                isInteractive={true}
            />

        </>


    )
}

export default GrowthLineGraph
